import { ListRow, ListRows, Skeleton, StatusTag } from '@westhetics/ui'
import type { SessionLike } from './api'
import { sessionMeta, sessionStatus } from './labels'

/**
 * A lista de acessos (RN-AUT-25), a mesma para a própria pessoa e para a gestora: dispositivo como
 * título, como e quando entrou na linha de contexto, o estado na etiqueta. Não há ação por acesso:
 * encerrar um dispositivo específico não existe na API; a senha nova encerra as outras sessões.
 */
export function SessionList({
  sessions,
  showClinic = false,
}: {
  sessions: SessionLike[]
  /** A clínica do acesso: só na conta da própria pessoa (a gestora não vê outras clínicas). */
  showClinic?: boolean
}) {
  return (
    <ListRows>
      {sessions.map((session) => {
        const status = sessionStatus(session)
        return (
          <ListRow
            key={session.sessionId}
            title={session.device.description}
            meta={sessionMeta(session, { showClinic })}
            trailing={<StatusTag level={status.level}>{status.label}</StatusTag>}
          />
        )
      })}
    </ListRows>
  )
}

/** O esqueleto com a forma das linhas, enquanto a lista carrega. */
export function SessionListSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div role="status" aria-label="Carregando" className="flex flex-col gap-2">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-[64px] w-full" />
      ))}
    </div>
  )
}
